var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "-100 -100 1300 1300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c50156e5-feea-4894-abac-8aef4739313e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "2ca9fb08-d157-47f7-b5c0-7f87f058bd90"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.21 0 0 2.21 571.12 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 117.23 4.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-398.63, -279.82)",
    d: "M 392.946 258.583 C 386.65 258.583 382.379 259.185 380.142 259.804 L 380.142 300.238 C 382.779 300.849 386.038 301.055 390.52 301.055 C 406.973 301.055 417.12 292.723 417.12 278.701 C 417.12 266.101 408.387 258.583 392.946 258.583 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-281.4, -275.4)",
    d: "M 494.426 197.019 L 481.2 197.019 L 481.2 133.203 C 481.2 132.802 481.137 132.404 481.084 131.998 C 481.063 129.464 480.257 126.975 478.522 125.006 L 372.325 3.691 C 372.293 3.66 372.262 3.649 372.24 3.618 C 371.607 2.911 370.869 2.32 370.089 1.814 C 369.858 1.656 369.625 1.527 369.383 1.392 C 368.707 1.026 367.99 0.717 367.252 0.496 C 367.052 0.443 366.872 0.361 366.672 0.306 C 365.87 0.119 365.037 0 364.193 0 L 103.2 0 C 91.282 0 81.6 9.693 81.6 21.601 L 81.6 197.014 L 68.377 197.014 C 51.328 197.014 37.504 210.832 37.504 227.884 L 37.504 388.426 C 37.504 405.47 51.328 419.302 68.377 419.302 L 81.601 419.302 L 81.601 529.2 C 81.601 541.107 91.283 550.801 103.201 550.801 L 459.601 550.801 C 471.508 550.801 481.201 541.108 481.201 529.2 L 481.201 419.302 L 494.427 419.302 C 511.471 419.302 525.298 405.475 525.298 388.432 L 525.298 227.89 C 525.297 210.838 511.47 197.019 494.426 197.019 Z M 103.2 21.605 L 353.393 21.605 L 353.393 132.115 C 353.393 138.082 358.234 142.915 364.193 142.915 L 459.6 142.915 L 459.6 197.023 L 103.2 197.023 L 103.2 21.605 Z M 299.641 236.24 L 299.641 373.181 L 268.56 373.181 L 268.56 236.24 L 299.641 236.24 Z M 133.649 261.829 L 133.649 236.24 L 233.013 236.24 L 233.013 254.112 L 169.215 346.772 L 169.215 347.573 L 234.031 347.573 L 234.031 373.181 L 127.559 373.181 L 127.559 356.517 L 192.781 262.644 L 192.781 261.83 L 133.649 261.83 L 133.649 261.829 Z M 459.601 523.353 L 103.2 523.353 L 103.2 419.302 L 459.6 419.302 L 459.6 523.353 L 459.601 523.353 Z M 436.208 310.395 C 425.64 320.352 410.01 324.824 391.711 324.824 C 387.65 324.824 383.985 324.613 381.143 324.218 L 381.143 373.182 L 350.462 373.182 L 350.462 238.054 C 360.018 236.433 373.433 235.212 392.322 235.212 C 411.423 235.212 425.028 238.875 434.182 246.191 C 442.91 253.094 448.816 264.463 448.816 277.89 C 448.816 291.295 444.334 302.669 436.208 310.395 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoZip);
export default __webpack_public_path__ + "static/media/ico-zip.b1669e06.svg";
export { ForwardRef as ReactComponent };